export default [
    {
        field: 'rut',
        type: 'rut',
        vuetifyProps: {
            label: 'RUT',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'names',
        type: 'text',
        vuetifyProps: {
            label: 'Nombre',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'last_name1',
        type: 'text',
        vuetifyProps: {
            label: 'Primer apellido',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'last_name2',
        type: 'text',
        vuetifyProps: {
            label: 'Segundo apellido',
        },
        value: '',
    },
    {
        field: 'email',
        type: 'text',
        vuetifyProps: {
            label: 'Correo electrónico',
        },
        rules: [ 'required', 'email' ],
        value: '',
    },
]